var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-calendar-check" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("appointments")) + "\n\t")
        ],
        1
      ),
      _c("filters", {
        staticClass: "filter-card",
        attrs: { options: _vm.getOptionsFilter },
        on: {
          requestFiltered: _vm.requestFiltered,
          clearAndRequest: _vm.clearAndRequest
        }
      }),
      _c("q-table", {
        staticClass: "q-mt-md",
        attrs: {
          data: _vm.appointments,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          filter: _vm.filter,
          loading: _vm.loading,
          "row-key": "id",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.requestAppointments
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    debounce: 600,
                    icon: "fas fa-search",
                    placeholder: _vm.$t("search")
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _vm.permissions.reports
                  ? _c(
                      "q-btn",
                      {
                        staticClass: "q-mr-sm",
                        attrs: {
                          color: "secondary",
                          icon: "fas fa-download",
                          disable: _vm.$buttonDelay(
                            "appointments_report_button_delay"
                          ),
                          label: _vm.$t("appointments_report")
                        },
                        on: {
                          click: function($event) {
                            return _vm.downloadReport()
                          }
                        }
                      },
                      [
                        _vm.$buttonDelay("appointments_report_button_delay")
                          ? _c(
                              "q-tooltip",
                              {
                                attrs: {
                                  anchor: "top middle",
                                  self: "bottom middle",
                                  offset: [10, 10]
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t("report_button_delay")) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("new"),
                    disable: !_vm.permissions.request_events
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "appointment",
                        params: { id: 0, permissions: _vm.permissions }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: col.show,
                          expression: "col.show"
                        }
                      ],
                      key: col.name,
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "id"),
                          expression: "showColumn(props.colsMap, 'id')"
                        }
                      ],
                      key: "id",
                      attrs: { "auto-width": "", props: props }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t")]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "title"),
                          expression: "showColumn(props.colsMap, 'title')"
                        }
                      ],
                      key: "title",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(props.row.title) + "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "code"),
                          expression: "showColumn(props.colsMap, 'code')"
                        }
                      ],
                      key: "code",
                      attrs: { props: props }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(props.row.code) + "\n\t\t\t")]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "tags"),
                          expression: "showColumn(props.colsMap, 'tags')"
                        }
                      ],
                      key: "tags",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            label: _vm.getQuantityTags(props.row.tags),
                            "no-ripple": ""
                          }
                        },
                        [
                          props.row.tags.length > 0
                            ? _c("q-tooltip", [
                                _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("tags")) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _vm._l(props.row.tags, function(
                                      tag,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.getTag(tag)) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.tags.length - 1 > index
                                          ? _c("span", [_vm._v(", ")])
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "presential_event_appointment__appointment_type__title"
                          ),
                          expression:
                            "\n\t\t\t\t\tshowColumn(\n\t\t\t\t\t\tprops.colsMap,\n\t\t\t\t\t\t'presential_event_appointment__appointment_type__title'\n\t\t\t\t\t)\n\t\t\t\t"
                        }
                      ],
                      key:
                        "presential_event_appointment__appointment_type__title",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.getAppointmentType(
                              props.row.appointment_type_id
                            )
                          ) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "user_requester_name_email"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'user_requester_name_email')"
                        }
                      ],
                      key: "user_requester_name_email",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.user_requester_name_email) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "instructors_list"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'instructors_list')"
                        }
                      ],
                      key: "instructors_list",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            label: props.row.instructors_list.length
                              ? props.row.instructors_list.length
                              : 0,
                            "no-ripple": ""
                          }
                        },
                        [
                          props.row.instructors_list.length
                            ? _c("q-tooltip", [
                                _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("instructor")) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _vm._l(props.row.instructors_list, function(
                                      instructor,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(instructor) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.instructors_list.length - 1 >
                                        index
                                          ? _c("span", [
                                              _vm._v(",\n\t\t\t\t\t\t\t\t")
                                            ])
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "company_branch_name"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'company_branch_name')"
                        }
                      ],
                      key: "company_branch_name",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.company_branch_name) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "qty_vacancies"),
                          expression:
                            "showColumn(props.colsMap, 'qty_vacancies')"
                        }
                      ],
                      key: "qty_vacancies",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.qty_vacancies) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "first_event_date"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'first_event_date')"
                        }
                      ],
                      key: "first_event_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.first_event_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "last_event_date"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'last_event_date')"
                        }
                      ],
                      key: "last_event_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.last_event_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "created_date"),
                          expression:
                            "showColumn(props.colsMap, 'created_date')"
                        }
                      ],
                      key: "created_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.created_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "updated_date"),
                          expression:
                            "showColumn(props.colsMap, 'updated_date')"
                        }
                      ],
                      key: "updated_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.updated_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "status"),
                          expression: "showColumn(props.colsMap, 'status')"
                        }
                      ],
                      key: "status",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getStatusIcon(props.row.status),
                            color: _vm.getStatusColorChip(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "actions"),
                          expression: "showColumn(props.colsMap, 'actions')"
                        }
                      ],
                      key: "actions",
                      attrs: { "auto-width": "", props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "fas fa-pencil-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "appointment",
                                params: {
                                  id: props.row.actions,
                                  customTab: false,
                                  permissions: _vm.permissions
                                }
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _vm.showGuests(props.row)
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                flat: "",
                                round: "",
                                color: "primary",
                                icon: "fas fa-list"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "appointment",
                                    params: {
                                      id: props.row.actions,
                                      status: props.row.status,
                                      customTab: true,
                                      autoDuplicate: false,
                                      permissions: _vm.permissions
                                    }
                                  })
                                }
                              }
                            },
                            [
                              _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("access_subscription_list_tooltip")
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      props.row.status === 9
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                disable: !_vm.permissions.request_events,
                                flat: "",
                                round: "",
                                color: "primary",
                                icon: "far fa-copy"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$router.push({
                                    name: "appointment",
                                    params: {
                                      id: props.row.actions,
                                      status: props.row.status,
                                      customTab: false,
                                      autoDuplicate: true,
                                      permissions: _vm.permissions
                                    }
                                  })
                                }
                              }
                            },
                            [
                              _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("duplicate_training_tooltip")
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      props.row.status === 8
                        ? _c(
                            "q-btn",
                            {
                              attrs: {
                                flat: "",
                                round: "",
                                color: "secondary",
                                icon: "fas fa-chart-line"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showPresentialReport(props.row)
                                }
                              }
                            },
                            [
                              _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "view_report_for_this_training_tooltip"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }
          },
          {
            key: "bottom-row",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { attrs: { colspan: "100%" } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            dense: "",
                            color: "secondary",
                            size: "small",
                            icon: "fas fa-cog"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_customize_columns = true
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("configure_table_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_customize_columns,
            callback: function($$v) {
              _vm.show_customize_columns = $$v
            },
            expression: "show_customize_columns"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveColumns()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("personalize_columns")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-md" },
                  _vm._l(_vm.columns, function(column, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "col-xs-12 col-sm-4",
                        style:
                          column.label === "#" ? "display: none !important" : ""
                      },
                      [
                        column.label && column.label != "#"
                          ? _c("q-checkbox", {
                              attrs: { label: _vm.$t(column.label) },
                              model: {
                                value: column.show,
                                callback: function($$v) {
                                  _vm.$set(column, "show", $$v)
                                },
                                expression: "column.show"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                ),
                _c("div", { staticClass: "row reverse gutter-md q-mt-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "fit",
                        attrs: {
                          icon: "fas fa-times",
                          color: "primary",
                          label: _vm.$t("close")
                        },
                        on: {
                          click: function($event) {
                            return _vm.saveColumns()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "100vw",
              maxWidth: "100vw",
              minHeight: "100vh"
            }
          },
          model: {
            value: _vm.show_report,
            callback: function($$v) {
              _vm.show_report = $$v
            },
            expression: "show_report"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("reports")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "relative",
                      width: "100%",
                      height: "0px",
                      "padding-bottom": "56.25%"
                    }
                  },
                  [
                    _c("iframe", {
                      staticStyle: {
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%"
                      },
                      attrs: { src: _vm.report_url, frameborder: "0" }
                    })
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "100vw",
              maxWidth: "100vw",
              minHeight: "100vh"
            }
          },
          model: {
            value: _vm.show_report,
            callback: function($$v) {
              _vm.show_report = $$v
            },
            expression: "show_report"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("reports")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "relative",
                      width: "100%",
                      height: "0px",
                      "padding-bottom": "56.25%"
                    }
                  },
                  [
                    _c("iframe", {
                      staticStyle: {
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%"
                      },
                      attrs: { src: _vm.report_url, frameborder: "0" }
                    })
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c(
                    "div",
                    { staticClass: "row full-width q-mb-xs" },
                    [
                      _c("q-btn", {
                        staticClass: "offset-4 col-4",
                        attrs: { color: "positive", label: _vm.$t("ok") },
                        on: {
                          click: function($event) {
                            _vm.show_report_problem = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_report_problem,
            callback: function($$v) {
              _vm.show_report_problem = $$v
            },
            expression: "show_report_problem"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("report_download_failed")))
          ]),
          _c("div", { attrs: { slot: "message" }, slot: "message" }, [
            _c("span", { staticClass: "q-pa-xs" }, [
              _vm._v(_vm._s(_vm.$t("report_download_failed_exceeded_time")))
            ]),
            _c("p", { staticClass: "q-pa-xs" }, [
              _vm._v(_vm._s(_vm.$t("the_report_it_will_be_sent_to_your_email")))
            ])
          ])
        ]
      ),
      _vm.show_billing_reports_modal
        ? _c("billing-reports", {
            attrs: { show: _vm.show_billing_reports_modal },
            on: {
              hideBillingReports: function($event) {
                return _vm.hideBillingReports()
              }
            }
          })
        : _vm._e(),
      _vm.show_report_presential
        ? _c("reports", {
            attrs: {
              show_report_presential: _vm.show_report_presential,
              id: _vm.action_id,
              status: _vm.action_status,
              title: _vm.action_title,
              permissions: _vm.permissions
            },
            on: {
              hide_report: function($event) {
                return _vm.hideReport()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }